// import VT from '@/store/types';

export default {
  // [VT.LABEL_SETS_LIST]: (state, { data, status }) => {
  //   state.labelSetsList = { data, status };
  // },
};
